<section id="cv-management" class="mb-4">
    <div class="row">
        <div [ngClass]="cvPreviewUrl ? 'col-xl-6' : 'col-xl-12'">
            <div class="upload-cv">
                <div class="row">
                    <div class="col-xl-12">
                        <div ng2FileDrop [ngClass]="{'nv-file-over': hasDropZoneOver}" (fileOver)="fileOverBase($event)"
                            [uploader]="uploader"
                            class="py-5 mb-3 text-center font-medium-5 text-uppercase grey my-drop-zone">
                            Zona de carga

                            <p class="small">Arrastra un CV aquí</p>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div [ngClass]="cvPreviewUrl ? 'col-12 col-xxl-3' : 'col-xl-3'">
                        <h4>Seleccionar CV desde el explorador</h4>
                        <div class="custom-file mb-3">
                            <input id="upload-file" type="file" aria-label="Seleccionar archivos" ng2FileSelect
                                [uploader]="uploader" hidden>
                            <label for="upload-file" class="btn btn-primary select-file">
                                <i class="ft-folder"></i>
                                <span class="ml-2">Seleccionar CV</span>
                            </label>
                        </div>
                        <div class="mt-2">
                            <h5>Tipos permitidos: </h5>
                            <ul class="d-flex flex-wrap">
                                <li class="w-50" *ngFor="let type of ALLOWED_FILE_TYPES_TEXT">
                                    {{ type }}
                                </li>
                            </ul>
                        </div>
                    </div>

                    <div [ngClass]="cvPreviewUrl ? 'col-12 col-xxl-9' : 'col-xl-9'">
                        <h4>Archivos seleccionados ({{ uploader?.queue?.length }})</h4>

                        <div class="table-responsive">
                            <table class="table">
                                <thead>
                                    <tr>
                                        <th width="50%">Nombre</th>
                                        <th>Tamaño</th>
                                        <th>Acciones</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngIf="uploader.queue.length === 0">
                                        <td colspan="3">
                                            <div *ngIf="uploader.queue.length === 0" class="no-selected">
                                                <span>Ningún archivo seleccionado.</span>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr *ngFor="let item of uploader.queue">
                                        <td><strong>{{ item?.file?.name }}</strong></td>
                                        <td nowrap>{{ item?.file?.size/1024/1024 | number:'.2' }}
                                            MB</td>
                                        <td nowrap>
                                            <button type="button" class="btn red-bg text-white btn-sm"
                                                (click)="discardFile(item)">
                                                <span class="fa fa-trash"></span> Descartar
                                            </button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
       <div *ngIf="cvPreviewUrl" class="col-xl-6 mt-xl-0 previewCv px-0">
            <!-- <iframe [src]="cvPreviewUrl" frameborder="0" class="w-100 h-100"></iframe> -->
  <pdf-viewer
  [src]="cvPreviewUrl"
  [render-text]="true"
  [original-size]="false"
  [zoom-scale]="'page-width'"
  [pdfViewer]="true"
[stick-to-page]="true"
  style="display: block; width: 100%; height: 100%;">
</pdf-viewer>

            
        </div>
    </div>
</section>

<ngx-spinner></ngx-spinner>